import { modals } from '@mantine/modals';
import {
  createSpotlight,
  Spotlight,
  type SpotlightActionData,
  type SpotlightActionGroupData,
} from '@mantine/spotlight';
import { i18nKeys, useTranslation } from 'locales';
import { useGetShortcutKeys } from 'modules/Settings/Profile';
import { TaskForm } from 'modules/Tasks';
import { useChangeLocale } from 'shared/hooks/use-change-locale';
import { useLogout } from 'shared/hooks/use-logout';

import { spotlightStylesOverride } from './NavigationSpotlight';

const [store, spotlightControls] = createSpotlight();

export const ActionsSpotlight = () => {
  const { t } = useTranslation();
  const logout = useLogout();

  const changeLocale = useChangeLocale();

  const { actions: shortcutKey } = useGetShortcutKeys();

  const actions: Array<SpotlightActionData | SpotlightActionGroupData> = [
    {
      group: 'Language',
      actions: [
        {
          id: 'setLangEn',
          label: t(i18nKeys.SPOTLIGHT.SET_LOCALE, { locale: 'EN' }),
          onClick: () => changeLocale('en'),
        },
        {
          id: 'setLangFr',
          label: t(i18nKeys.SPOTLIGHT.SET_LOCALE, { locale: 'FR' }),
          onClick: () => changeLocale('fr'),
        },
        {
          id: 'setLangNl',
          label: t(i18nKeys.SPOTLIGHT.SET_LOCALE, { locale: 'NL' }),
          onClick: () => changeLocale('nl'),
        },
      ],
    },
    {
      group: 'Quick actions',
      actions: [
        {
          id: 'task',
          label: 'Create new task',
          onClick: () => {
            modals.open({
              title: t(i18nKeys.FORM.TASK.NEW),
              size: 'xl',
              children: <TaskForm />,
            });
          },
        },
      ],
    },
    {
      group: 'Other',
      actions: [
        {
          id: 'logout',
          label: 'Logout',
          onClick: logout,
          description: 'Profile',
        },
      ],
    },
  ];

  return (
    <Spotlight
      actions={actions}
      store={store}
      shortcut={shortcutKey}
      centered
      limit={7}
      radius={10}
      highlightQuery
      onQueryChange={query => {
        if (query === shortcutKey) spotlightControls.close();
      }}
      classNames={{
        action: spotlightStylesOverride.action,
      }}
    />
  );
};
